// Bilingual UI copy (English default). DB content (clinic names/descriptions,
// blog posts, testimonials) is intentionally NOT translated here.
export const translations = {
  en: {
    common: {
      getFreeQuote: "Get Free Quote",
      getMyFreeQuote: "Get my free quote",
      callUsNow: "Call Us Now",
      bookCall: "Book a Call",
      talkToCoordinator: "Talk to a coordinator",
      whatsappUs: "WhatsApp us",
      chatWhatsApp: "Chat on WhatsApp",
      textUs: "Text us",
      freeQuote: "Free Quote",
      viewClinic: "View clinic →",
      realPatient: "Real patient",
      verifiedPatient: "Verified patient",
      replyWithin2h: "Free · no obligation · we reply within 2 hours.",
      sending: "Sending…",
      loading: "Loading…",
    },
    nav: { home: "Home", locations: "Locations", clinics: "Clinics", trip: "Your Trip", stories: "Patient Stories", guides: "Guides" },
    lang: { switchTo: "Español", label: "Language" },
    topbar: { us: "US" },
    footer: {
      blurb: "Top-rated, hand-picked dental clinics in Mexico, Costa Rica, Colombia & Turkey. US-level quality without the US price tag — with nearly 16,000 patients guided.",
      explore: "Explore",
      destinations: "Destinations",
      compareClinics: "Compare Clinics",
      tripPlan: "Your Trip Plan",
      smileTransformations: "Smile Transformations",
      patientStories: "Patient Stories",
      guides: "Dental Tourism Guides",
      contact: "Contact",
      chatWhatsApp: "Chat on WhatsApp",
      rights: "All rights reserved.",
    },
    announce: {
      bold: "First time traveling abroad? No worries.",
      rest: "Our patient coordinators can book your flights & coordinate airport/border pickup.",
      cta: "Talk to a coordinator",
    },
    exit: {
      title: "Before you go — see what you could save",
      sub: "Get a free, no-obligation quote from our vetted clinics. Most patients save 50–70% versus U.S. prices — and our team replies within 2 hours.",
      cta: "Get my free quote",
      dismiss: "Maybe later",
    },
    social: [
      { t: "Free written quotes", d: "Our team typically replies within 2 hours" },
      { t: "Save 50–70% vs. U.S. prices", d: "Same premium materials & US-trained specialists" },
      { t: "Partners, not brokers", d: "Every clinic personally vetted in person" },
      { t: "All-inclusive trips", d: "Hotel, shuttle & bilingual concierge included" },
      { t: "Nearly 16,000 patients guided", d: "Across Mexico, Costa Rica, Colombia & Turkey" },
    ],
    quote: {
      procedures: ["Full Veneers", "Crowns", "Dental Implant", "All on 4", "All on 6", "Root Canal", "Teeth Whitening", "Hollywood Smile", "Other"],
      contactMethods: ["Phone call", "Text message (SMS)", "Email", "WhatsApp"],
      bestTimes: ["Anytime / not sure", "Morning (8am–12pm)", "Afternoon (12pm–5pm)", "Evening (5pm–8pm)"],
      successToast: "Request sent! A patient coordinator will reach out in about 1 hour — keep your phone handy.",
      errorToast: "Failed to send request",
      allSet: "You're all set, {name}!",
      successBody: "One of our patient coordinators will reach out to you in about 1 hour. Please keep your phone handy — and if we can't reach you by call, we'll follow up with a text or an email at {email}.",
      done: "Done",
      title: "Talk to a coordinator",
      intro: "Tell us a little about you and a friendly patient coordinator will personally reach out — free, no obligation, and no pressure. We're here to answer your questions first.",
      treatmentLabel: "What treatment are you interested in?",
      selectProcedure: "Select a procedure",
      fullName: "Full name",
      phone: "Phone",
      email: "Email",
      bestContact: "Best way to contact you",
      bestTime: "Best time to call",
      messageLabel: "Message to our specialists",
      optional: "(optional)",
      messagePlaceholder: "Tell us about your dental needs, questions or timeline…",
      submit: "Talk to a coordinator",
      footnote: "100% free & confidential · We usually reply within about 1 hour",
    },
    calc: {
      procedures: { "Single Implant": "Single Implant", "All-on-4 (per arch)": "All-on-4 (per arch)", "All-on-6 (per arch)": "All-on-6 (per arch)", "Crowns": "Crowns", "Veneers": "Veneers" },
      title: "Savings Calculator",
      sub: "See how much you could save abroad.",
      procedureLabel: "Procedure",
      quantity: "Quantity / units:",
      perArchNote: "All-on-4 & All-on-6 are priced per arch — set units to 2 for a full mouth (both arches).",
      usaCanada: "USA / Canada",
      abroad: "Abroad",
      youSave: "You save",
      thatsOff: "that's {pct}% off",
      cta: "Get an exact quote for {procedure}",
    },
    home: {
      heroBadge: "US-trained clinics · 16,000+ patients guided",
      heroTitle1: "Stop overpaying for your smile.",
      heroTitle2: "Save up to 70%.",
      heroSub: "Top-rated, hand-picked dental clinics in <b>Mexico, Costa Rica, Colombia & Turkey</b>. US-level quality on implants, veneers, crowns and All-on-4 — without the US price tag.",
      statAvg: "avg across our clinics",
      statPatients: "patients guided",
      statCountries: "countries",
      guaranteeBadge: "Clinic-backed guarantee",
      guaranteeBadgeSub: "Signed with your clinic in person",
      certsTitle: "Our experts' training & certifications",
      certsFootnote: "US &amp; international accreditations · premium, brand-name implants &amp; lab materials (<b>Straumann</b>, <b>Nobel Biocare</b>, <b>Zirkonzahn</b> &amp; more).",
      clinicsEyebrow: "Partners, not brokers",
      clinicsTitle: "Clinics we know personally",
      clinicsSub: "We're not a booking site or a middleman passing you along. My Global Dentist partners directly with each clinic and its dentists — so when it comes to quality, pricing and warranties, there are real people standing behind you. Hotel, shuttle & concierge support included.",
      browseClinics: "Browse by location & filters →",
      transformsEyebrow: "Proof in every smile",
      transformsTitle: "Real smile transformations",
      transformsSub: "Real results from patients across our network — full-arch implants, All-on-4, All-on-6 and full-mouth reconstructions.",
      swipeMore: "Swipe to see more →",
      seeVideos: "See video testimonials",
      seeCandidate: "See if I'm a candidate",
      candidateNote: "Free, no-obligation review — we reply within 2 hours.",
      testimonialsEyebrow: "Patient stories",
      testimonialsTitle: "In their own words",
      saraQuote: "\"My only regret is not doing it sooner.\"",
      saraName: "Sara Misterek",
      saraProcedure: "Full Mouth Restoration with Crowns",
      saraVerified: "Verified patient · in her own words",
      shareBold: "Are you one of our patients?",
      shareRest: "Share your story and inspire someone who's still nervous to take the leap.",
      shareStory: "Share your story",
      conciergeBadge: "Full trip concierge",
      conciergeTitle1: "First time traveling abroad?",
      conciergeTitle2: "We've got you covered.",
      conciergeSub: "Many of our patients have never traveled abroad — and that's okay. Your dedicated coordinator handles every detail, so you just show up and smile.",
      conciergeTalk: "Talk to a coordinator now",
      conciergeJourney: "See your day-by-day 4-day trip plan",
      shuttleBadge: "More pickup points than anyone",
      shuttleTitle: "Free shuttles from more places than any other dental service",
      shuttleSub: "We meet you where you land or cross and take you straight to your clinic and hotel.",
      flyDomesticBold: "Heading to a border-town clinic?",
      flyDomesticRest: "No need to fly international — fly domestic to a nearby US city and we'll pick you up and drive you across. For Cancún, Costa Rica, Colombia & Turkey, there are easy direct international flights.",
      arrangeShuttle: "Arrange my shuttle",
      allPickups: "All pickup locations",
      noCity: "Don't see your city? Talk to a coordinator",
      vettedEyebrow: "The proof, not just a promise",
      vettedTitle: "We've stood inside every clinic on this site",
      vettedSub: "These are our own visits — inspecting each facility, meeting the doctors and awarding our International Quality Recognition before any clinic joins the network. If we haven't been there in person, you won't find them here.",
      vettedFootnote: "Every partner clinic is inspected in person and quality-certified by our founder.",
      vettedVisiting: "Founder visiting {name}",
      howEyebrow: "Simple & transparent",
      howTitle: "How it works",
      howSub: "From first quote to final smile, we handle the details so you can travel with confidence.",
      founderEyebrow: "A message from our founder",
      founderTitle: "Your smile deserves care you can trust",
      founderP1: "\"I started My Global Dentist after watching too many hard-working families put off the dental care they needed simply because it cost too much at home. That never sat right with me.",
      founderP2: "So I began traveling — walking the floors of clinics across Mexico, Costa Rica, Colombia and Turkey, meeting the dentists, checking the sterilization rooms, and asking the questions <i>you</i> would ask. Only the very best earn a place in our network.",
      founderP3: "Nearly 16,000 patients later, this is still personal to me. When you reach out, you're not a number — you're someone we'll guide, protect and celebrate when you finally see your new smile in the mirror.\"",
      founderRole: "Founder, My Global Dentist",
      founderReach: "Want to reach me personally?",
      founderReadMsg: "I read every message myself.",
      founderTalk: "Talk to our team",
      founderReadFull: "Read my full welcome",
      destEyebrow: "Where we work",
      destTitle: "Explore our destinations",
      destAll: "All destinations →",
      mathEyebrow: "The math is simple",
      mathTitle: "Save 50–70% — same premium materials",
      mathSub: "Same premium materials, the same US-trained specialists — at a fraction of the price. Here's what our patients typically pay versus the United States.",
      inUsa: "In the USA",
      withUsFrom: "With us from",
      saveUpTo: "Save up to {save}",
      mathFootnote: "Typical all-inclusive ranges. Your exact price is confirmed in your free written quote.",
      getWrittenQuote: "Get my written quote",
      faqEyebrow: "Your questions, answered",
      faqTitle: "Frequently asked questions",
      humanBadge: "Real humans · No bots",
      humanTitle: "Talk to a real person — not a bot.",
      humanSub: "Speak with an experienced coordinator who has helped thousands of patients. They'll walk you through your options, costs and timeline — no pressure, no scripts.",
      humanQuoteBtn: "Get a free quote",
      humanCallBtn: "Call a coordinator",
      finalTitle: "Unsure where to start?",
      finalSub: "Our patient care team is here to guide you every step of the way. Get a free, no-obligation quote — we respond within 2 hours.",
      compareRows: [
        { t: "All-on-4 (per arch)", us: "$26,000", ours: "$8,500", save: "67%" },
        { t: "Single implant", us: "$4,000", ours: "$800", save: "80%" },
        { t: "Porcelain veneer (each)", us: "$1,800", ours: "$400", save: "78%" },
      ],
      guarantees: [
        { t: "Clinic-backed treatment guarantee", d: "Signed directly between you and your clinic, in person." },
        { t: "US-trained, certified dentists", d: "ADA members and internationally accredited specialists only." },
        { t: "No hidden fees, ever", d: "One transparent all-inclusive price — surgery, materials & follow-up." },
      ],
      concierge: [
        { title: "Flight booking help", desc: "We'll help you find and book the best flights for your treatment dates." },
        { title: "Airport & border pickup", desc: "Free shuttles from international airports, US border crossings and city pickup points — straight to your clinic and hotel." },
        { title: "Hotels & private Airbnbs", desc: "Partner-rate hotels and hand-picked private Airbnbs near your clinic, matched to your budget." },
        { title: "Bilingual support", desc: "English-speaking staff and coordinators with you at every appointment." },
      ],
      steps: [
        { title: "Get a free quote", desc: "Tell us your treatment. Receive a personalized plan and price in 2 hours." },
        { title: "Match with a clinic", desc: "We pair you with a hand-picked, US-trained clinic with bilingual staff." },
        { title: "Travel & treat", desc: "We coordinate flights, hotels and appointments end-to-end." },
        { title: "Smile & save", desc: "Return home with a new smile — and up to 70% saved." },
      ],
      faqs: [
        { q: "Is dental tourism actually safe?", a: "Yes — when you choose the right clinic. Every clinic in our network is hand-picked and vetted for accreditation (ADA, ISO, JCI), modern sterilization, US/EU-trained dentists and verified patient reviews. We've personally walked their floors." },
        { q: "How can prices be 70% lower — is the quality worse?", a: "No. Lower costs come from lower overhead, labor and insurance costs abroad, not lower quality. Our partner clinics use the same premium implant brands and materials (Straumann, Nobel, Zirconia) you'd get at home." },
        { q: "Will I really save money after flights and hotel?", a: "For most major treatments, absolutely. On a single implant you save ~$2,600; on All-on-4 or full veneers you save $10,000–$40,000 — far more than any travel cost. Many patients treat it as a paid vacation." },
        { q: "How long do I need to stay?", a: "It depends on the treatment. Crowns and veneers often take 3–5 days; implants may need one short trip for placement and a follow-up for the crown. Your coordinator plans everything around your schedule." },
        { q: "What if something goes wrong after I get home?", a: "Your clinic provides a written treatment guarantee that you review and sign together in person, and our patient care team stays with you before, during and after your trip to coordinate any follow-up needed." },
        { q: "How do I get started?", a: "Request a free quote (takes under a minute) or message us on WhatsApp. We'll send a personalized treatment plan and price within 24 hours — no obligation." },
      ],
      locations: {
        tijuana: { title: "Tijuana, Mexico", sub: "Fly from anywhere in the US · shuttles from San Diego & Palm Springs" },
        mexicali: { title: "Mexicali, Mexico", sub: "Fly from anywhere in the US · shuttle from Calexico, CA" },
        algodones: { title: "Los Algodones, Mexico", sub: "\u201CMolar City\u201D · Fly from anywhere in the US · shuttles from San Diego, Yuma & Phoenix" },
        cancun: { title: "Cancún, Mexico", sub: "Direct flights from the US & Canada" },
        costarica: { title: "San José, Costa Rica", sub: "Direct flights from the US & Canada" },
        colombia: { title: "Bogotá, Colombia", sub: "Direct flights from the US & Canada" },
        turkey: { title: "Istanbul, Turkey", sub: "The global capital of smile makeovers" },
        progreso: { title: "Nuevo Progreso, Mexico", sub: "Fly from anywhere in the US · shuttle from McAllen, TX" },
      },
    },
    ad: {
      differentiators: [
        { t: "Partners, not brokers", d: "Every clinic personally vetted in person" },
        { t: "US-trained dentists", d: "ADA / AACD-accredited specialists" },
        { t: "Clinic-backed guarantee", d: "Signed with your clinic, in person" },
        { t: "All-inclusive trip", d: "Hotel, free shuttle & bilingual concierge" },
      ],
      times: ["Morning (8am–12pm)", "Afternoon (12–5pm)", "Evening (5–8pm)", "Anytime"],
      variants: {
        implants: { eyebrow: "Dental implants abroad", h1a: "Dental implants for", h1b: "up to 77% less", sub: "US-trained specialists and genuine Straumann & Nobel implants — from $800 vs. ~$4,000 in the US. Same premium quality, a fraction of the price.", unit: "per implant" },
        "all-on-4": { eyebrow: "All-on-4 full-arch", h1a: "A brand-new smile with", h1b: "All-on-4 — save up to 67%", sub: "Full-arch fixed teeth on 4 implants — from $8,500 per arch vs. ~$26,000 in the US. US-trained surgeons, premium materials and an all-inclusive trip.", unit: "per arch" },
        "veneers-crowns": { eyebrow: "Veneers & crowns", h1a: "A flawless new smile with", h1b: "veneers & crowns — save up to 78%", sub: "Hand-crafted porcelain veneers and crowns — from $400 each vs. ~$1,800 in the US. Same premium materials, US-trained cosmetic dentists.", unit: "per tooth" },
      },
      avg: "avg",
      patientsGuided: "patients guided",
      thankYou: "Thank you! 🎉",
      thankYouSub: "Our team will send your personalized quote within 2 hours. Prefer to chat now?",
      freeReply2h: "Free · reply in 2h",
      formTitle: "Get your free written quote",
      formSub: "No obligation. 100% confidential.",
      fullName: "Full name",
      email: "Email",
      phoneWa: "Phone / WhatsApp",
      bestTime: "Best time to call",
      chooseTime: "Choose a time",
      error: "Something went wrong. Please try again or WhatsApp us.",
      mathEyebrow: "The math is simple",
      inUsa: "In the USA",
      withUsFrom: "With us from",
      saveUpTo: "Save up to {save}",
      mathFootnote: "Typical all-inclusive range. Your exact price is confirmed in your free written quote.",
      proofEyebrow: "Proof in every smile",
      proofTitle: "Real patients, real results",
      watchVideos: "Watch video testimonials",
      finalTitle: "Ready to see your savings?",
      finalSub: "Get a free, no-obligation quote — our team replies within 2 hours.",
      exploreFull: "Explore the full My Global Dentist site →",
    },
    compare: {
      eyebrow: "Find your match",
      title: "Compare dental clinics",
      sub: "Browse accredited clinics by location, or filter by procedure, price and certifications.",
      filters: "Filters",
      reset: "Reset",
      country: "Country",
      anyCountry: "Any country",
      procedure: "Procedure",
      anyProcedure: "Any procedure",
      certification: "Certification",
      anyCertification: "Any certification",
      maxPrice: "Max starting price:",
      allLocations: "All locations",
      found: "{n} clinics found",
      foundOne: "1 clinic found",
      noMatch: "No clinics match your filters.",
      clearFilters: "Clear filters",
      cityGuide: "{city} guide →",
    },
    video: {
      back: "Back to home",
      badge: "Real patients · real results",
      title: "Video testimonials",
      subN: "{n} real stories from patients across our partner clinics in Mexico, Costa Rica, Colombia & Turkey — in their own words.",
      sub: "Real stories from patients across our partner clinics in Mexico, Costa Rica, Colombia & Turkey — in their own words.",
      loading: "Loading video stories…",
      ctaTitle: "Ready to write your own story?",
      ctaSub: "Get a free, no-obligation treatment plan and price — we reply within 2 hours.",
    },
    transforms: {
      back: "Home",
      eyebrow: "Proof in every smile",
      title: "Real smile transformations",
      sub: "Real results from real patients in our network — full-arch implants, All-on-4, All-on-6 and full-mouth reconstructions. See the before & after side by side.",
      ctaTitle: "Your transformation could be next",
      ctaSub: "Get a free, personalized treatment plan and price in 2 hours — no obligation.",
    },
    stories: {
      eyebrow: "Real people, real smiles",
      title: "Patient stories",
      sub: "Authentic experiences from patients across our clinics in Mexico, Costa Rica, Colombia & Turkey.",
      emptyTitle: "Our first stories are on the way",
      emptySub: "We're a growing network and we only publish <b>real, verified</b> patient experiences — never fake reviews. If you've traveled with us, we'd love to feature your smile.",
      share: "Share your story",
      ctaTitle: "Traveled with us? Share your smile.",
      ctaSub: "Help future patients feel confident — add your story, photo or video.",
      watchVideo: "Watch video story",
    },
    share: {
      procedures: ["Full Veneers", "Crowns", "Dental Implant", "All on 4", "All on 6", "Root Canal", "Teeth Whitening", "Hollywood Smile", "Other"],
      errValidate: "Please add your name and a story of at least 10 characters.",
      errSubmit: "Failed to submit",
      thankYou: "Thank you, {name}!",
      thankYouSub: "Your story has been received. Our team reviews every submission to keep our gallery <b>100% real</b> — once approved, your smile will help future patients feel confident.",
      viewStories: "View patient stories",
      title: "Share your smile story",
      sub: "Traveled with us? Inspire the next patient. We only publish <b>real, verified</b> experiences — never fake reviews.",
      name: "Your name *",
      from: "Where you're from",
      procedure: "Procedure",
      select: "Select",
      clinic: "Clinic you visited",
      emailLabel: "Your email",
      emailPrivate: "(private, so we can verify)",
      rating: "Your rating",
      story: "Your story *",
      storyPlaceholder: "Tell us about your experience — the results, the care, the trip…",
      addPhoto: "Add a photo (optional)",
      addVideo: "Add a video (optional)",
      submit: "Submit my story",
      reviewed: "Reviewed by our team before publishing",
    },
    locations: {
      eyebrow: "Where we work",
      title: "Our destinations",
      sub: "Hand-picked dental cities across Mexico, Costa Rica, Colombia & Turkey. Explore each destination — what to do, how to get there, and the clinics waiting for you.",
      explore: "Explore {city}",
      notFound: "Location not found.",
      allDestinations: "All destinations",
      about: "About {city}",
      whatToDo: "What to do in {city}",
      howToGet: "How to get to {city}",
      coordinatorPickup: "Your coordinator arranges pickup & guides you the whole way.",
      clinicsIn: "Clinics in {city}",
      clinicsNear: "Clinics near {city}",
      addingSoon: "We're adding clinics in {city} soon —",
      requestQuote: "request a quote",
      addingSoon2: "and we'll match you with the best option.",
      quickFacts: "Quick facts",
      factGetting: "Getting there",
      factEntry: "Entry point",
      factCurrency: "Currency",
      factLanguage: "Language",
      factWeather: "Weather",
      factBestFor: "Best for",
      planTrip: "Plan your {city} trip",
      planSub: "Free quote & full trip coordination — we reply in 2 hours.",
    },
    trip: {
      badge: "Full trip concierge",
      title: "What to expect on your trip",
      sub: "A typical dental trip takes about <b>4 days</b>. Here's exactly how it works — planned end-to-end by your dedicated patient coordinator, so first-timers feel completely at ease.",
      goodToKnow: "Good to know:",
      goodToKnowRest: "timelines vary by treatment. Simple crowns and veneers can be done in 3–4 days, while dental implants sometimes need a short second visit for the final crown once healing is complete. Your coordinator tailors the plan to your case and travel dates.",
      ctaTitle: "Ready to plan your trip?",
      ctaSub: "Tell us your treatment and travel dates — we'll build your day-by-day plan and a free quote within 2 hours.",
      days: [
        { day: "Day 1", title: "Arrival & welcome", points: ["You land — your coordinator arranges airport or border pickup.", "Check in to a partner hotel close to your clinic at preferred rates.", "Relax and settle in; no treatment today."] },
        { day: "Day 2", title: "Consultation & treatment plan", points: ["Visit the clinic for a full exam, digital X-rays and 3D scan.", "Your dentist confirms a personalized treatment plan and final pricing.", "First-stage work begins (cleaning, preparation or temporaries)."] },
        { day: "Day 3", title: "Treatment day", points: ["Your main procedure — implant placement, veneers or crown work.", "Comfortable, pain-managed care with your bilingual coordinator nearby.", "Time to rest and enjoy the city between appointments."] },
        { day: "Day 4", title: "Final fitting & fly home", points: ["Final adjustments, fitting and a quality check on your new smile.", "Clear aftercare instructions and your coordinator's direct contact.", "Transport arranged back to the airport or border — fly home smiling."] },
      ],
    },
    blog: {
      eyebrow: "Resources",
      title: "Dental tourism guides",
      sub: "Everything you need to plan a safe, affordable trip for your smile.",
      readGuide: "Read guide →",
      notFound: "Post not found.",
      backToGuides: "Back to guides",
      allGuides: "All guides",
      by: "By {author}",
      ctaTitle: "Ready to save on your treatment?",
      ctaSub: "Get a free personalized quote from a vetted clinic.",
    },
    clinic: {
      notFound: "Clinic not found.",
      backToClinics: "All clinics",
      featured: "Featured",
      reviews: "{n} reviews",
      yrsExp: "{n} yrs experience",
      certifications: "Certifications",
      languagesSpoken: "Languages spoken",
      inHouseLab: "In-house laboratory",
      whatsIncluded: "What's included",
      allInclusive: "All-inclusive packages",
      allInclusiveSub: "Transparent, all-in care coordinated for you — treatment, hotel and airport shuttles included. Every case is unique, so talk to a coordinator for your personalized package.",
      allInclusiveBadge: "All-inclusive package",
      pricingFor: "Pricing for this package:",
      talkToCoordinator: "Talk to a coordinator",
      pkgo: {
        "All-on 4/6 Full Arch": "All-on 4/6 Full Arch",
        "As many implants as necessary": "As many implants as necessary",
        "Three nights of hotel per trip": "Three nights of hotel per trip",
        "Four nights of hotel per trip": "Four nights of hotel per trip",
        "Five nights of hotel per trip": "Five nights of hotel per trip",
        "Five nights of hotel · Renaissance Hotel": "Five nights of hotel · Renaissance Hotel",
      },
      smileTransforms: "Smile transformations",
      dragSlider: "Drag the slider to reveal real before & after results.",
      featuredCase: "Featured full-arch case",
      patientStories: "Patient stories",
      patientStoriesSub: "Real, verified experiences from patients treated here.",
      patientVideos: "Patient videos",
      location: "Location",
      mapNote: "Your coordinator sends exact directions and arranges your free shuttle from the border or airport — no need to find us on your own.",
      stickyEyebrow: "All-inclusive packages",
      stickySave: "Save up to 70% vs. the US",
      stickySub: "Treatment, hotel & airport pickup — coordinated for you. We respond within 2 hours.",
      respond2h: "We respond within 2 hours",
      waMessage: "Hi! I'm interested in treatment at {name}.",
      highlights: { "First clinic after the bridge": "First clinic after the bridge", "Open Sundays": "Open Sundays" },
      proximity: {
        "Mexicali": "About 5 minutes from the Calexico (California) US border",
        "Tijuana": "About 15–20 minutes from the San Diego (San Ysidro) US border",
        "Los Algodones": "Walking distance from the Andrade / Yuma (Arizona) US border",
        "Nuevo Progreso": "Steps from the Progreso (Weslaco, Texas) US border",
        "Cancún": "About 20 minutes from Cancún International Airport (CUN)",
        "Bogotá": "About 25 minutes from El Dorado International Airport (BOG)",
        "San José": "About 20 minutes from Juan Santamaría International Airport (SJO)",
        "Istanbul": "About 40 minutes from Istanbul Airport (IST)",
      },
      packages: {
        allOnDefault: "All-on-4 Full Arch",
        allOnTagline: "Fixed, permanent teeth — full arch",
        allOnItems: ["CT scans & evaluations", "Specialist consultations", "IV sedation", "Extractions", "Bone grafting", "Four implants per jaw", "Temporary fixed teeth", "Final permanent teeth", "3 nights of hotel per trip", "Airport shuttles (round-trip)"],
        smileName: "Smile Makeover · Full Mouth",
        smileTagline: "Full-mouth restoration with crowns",
        smileItems: ["CT scan & evaluations", "Specialist consultations", "Up to 24 zirconia / E.max crowns", "Digital Smile Design", "All laboratory work", "Hotel & shuttles included"],
      },
    },
    card: {
      hotel: "Hotel", shuttle: "Shuttle", concierge: "Concierge", featured: "Featured",
      highlights: { "First after the bridge": "First after the bridge", "Open Sundays": "Open Sundays" },
      proximity: {
        "Mexicali": "5 min to the US border",
        "Tijuana": "15 min to the US border",
        "Los Algodones": "Walk across the US border",
        "Nuevo Progreso": "Steps to the US border",
        "Cancún": "20 min from CUN airport",
        "Bogotá": "30 min from BOG airport",
        "San José": "20 min from SJO airport",
        "Istanbul": "40 min from IST airport",
      },
    },
    tcard: { before: "Before", after: "After", realPatient: "Real patient" },
  },

  es: {
    common: {
      getFreeQuote: "Cotización gratis",
      getMyFreeQuote: "Quiero mi cotización gratis",
      callUsNow: "Llámanos ahora",
      bookCall: "Agendar llamada",
      talkToCoordinator: "Habla con un coordinador",
      whatsappUs: "Escríbenos por WhatsApp",
      chatWhatsApp: "Chatea por WhatsApp",
      textUs: "Envíanos un SMS",
      freeQuote: "Cotización gratis",
      viewClinic: "Ver clínica →",
      realPatient: "Paciente real",
      verifiedPatient: "Paciente verificado",
      replyWithin2h: "Gratis · sin compromiso · respondemos en menos de 2 horas.",
      sending: "Enviando…",
      loading: "Cargando…",
    },
    nav: { home: "Inicio", locations: "Destinos", clinics: "Clínicas", trip: "Tu viaje", stories: "Historias", guides: "Guías" },
    lang: { switchTo: "English", label: "Idioma" },
    topbar: { us: "EE.UU." },
    footer: {
      blurb: "Clínicas dentales de primer nivel, seleccionadas a mano en México, Costa Rica, Colombia y Turquía. Calidad de EE.UU. sin el precio de EE.UU. — con casi 16,000 pacientes acompañados.",
      explore: "Explorar",
      destinations: "Destinos",
      compareClinics: "Comparar clínicas",
      tripPlan: "Tu plan de viaje",
      smileTransformations: "Transformaciones de sonrisa",
      patientStories: "Historias de pacientes",
      guides: "Guías de turismo dental",
      contact: "Contacto",
      chatWhatsApp: "Chatea por WhatsApp",
      rights: "Todos los derechos reservados.",
    },
    announce: {
      bold: "¿Primera vez viajando al extranjero? Tranquilo.",
      rest: "Nuestros coordinadores pueden reservar tus vuelos y coordinar el traslado desde el aeropuerto o la frontera.",
      cta: "Habla con un coordinador",
    },
    exit: {
      title: "Antes de irte — mira cuánto podrías ahorrar",
      sub: "Recibe una cotización gratis y sin compromiso de nuestras clínicas verificadas. La mayoría de los pacientes ahorra entre 50 y 70% frente a los precios de EE.UU. — y nuestro equipo responde en 2 horas.",
      cta: "Quiero mi cotización gratis",
      dismiss: "Quizás después",
    },
    social: [
      { t: "Cotizaciones gratis por escrito", d: "Nuestro equipo suele responder en 2 horas" },
      { t: "Ahorra 50–70% vs. precios de EE.UU.", d: "Mismos materiales premium y especialistas formados en EE.UU." },
      { t: "Socios, no intermediarios", d: "Cada clínica visitada y verificada en persona" },
      { t: "Viajes todo incluido", d: "Hotel, traslado y concierge bilingüe incluidos" },
      { t: "Casi 16,000 pacientes acompañados", d: "En México, Costa Rica, Colombia y Turquía" },
    ],
    quote: {
      procedures: ["Carillas completas", "Coronas", "Implante dental", "All on 4", "All on 6", "Endodoncia", "Blanqueamiento", "Diseño de sonrisa", "Otro"],
      contactMethods: ["Llamada telefónica", "Mensaje de texto (SMS)", "Correo electrónico", "WhatsApp"],
      bestTimes: ["Cualquier hora / no estoy seguro", "Mañana (8am–12pm)", "Tarde (12pm–5pm)", "Noche (5pm–8pm)"],
      successToast: "¡Solicitud enviada! Un coordinador de pacientes te contactará en aproximadamente 1 hora — ten tu teléfono a la mano.",
      errorToast: "No se pudo enviar la solicitud",
      allSet: "¡Todo listo, {name}!",
      successBody: "Uno de nuestros coordinadores de pacientes te contactará en aproximadamente 1 hora. Por favor ten tu teléfono a la mano — y si no logramos comunicarnos por llamada, te escribiremos por SMS o al correo {email}.",
      done: "Listo",
      title: "Habla con un coordinador",
      intro: "Cuéntanos un poco sobre ti y un coordinador de pacientes te contactará personalmente — gratis, sin compromiso y sin presión. Estamos aquí para responder tus preguntas primero.",
      treatmentLabel: "¿Qué tratamiento te interesa?",
      selectProcedure: "Selecciona un procedimiento",
      fullName: "Nombre completo",
      phone: "Teléfono",
      email: "Correo electrónico",
      bestContact: "Mejor forma de contactarte",
      bestTime: "Mejor hora para llamar",
      messageLabel: "Mensaje para nuestros especialistas",
      optional: "(opcional)",
      messagePlaceholder: "Cuéntanos sobre tus necesidades dentales, preguntas o fechas…",
      submit: "Habla con un coordinador",
      footnote: "100% gratis y confidencial · Normalmente respondemos en aproximadamente 1 hora",
    },
    calc: {
      procedures: { "Single Implant": "Implante individual", "All-on-4 (per arch)": "All-on-4 (por arcada)", "All-on-6 (per arch)": "All-on-6 (por arcada)", "Crowns": "Coronas", "Veneers": "Carillas" },
      title: "Calculadora de ahorros",
      sub: "Descubre cuánto podrías ahorrar en el extranjero.",
      procedureLabel: "Procedimiento",
      quantity: "Cantidad / unidades:",
      perArchNote: "All-on-4 y All-on-6 se cotizan por arcada — pon 2 unidades para boca completa (ambas arcadas).",
      usaCanada: "EE.UU. / Canadá",
      abroad: "En el extranjero",
      youSave: "Ahorras",
      thatsOff: "eso es {pct}% menos",
      cta: "Obtén una cotización exacta de {procedure}",
    },
    home: {
      heroBadge: "Clínicas formadas en EE.UU. · 16,000+ pacientes acompañados",
      heroTitle1: "Deja de pagar de más por tu sonrisa.",
      heroTitle2: "Ahorra hasta 70%.",
      heroSub: "Clínicas dentales de primer nivel, seleccionadas a mano en <b>México, Costa Rica, Colombia y Turquía</b>. Calidad nivel EE.UU. en implantes, carillas, coronas y All-on-4 — sin el precio de EE.UU.",
      statAvg: "promedio en nuestras clínicas",
      statPatients: "pacientes acompañados",
      statCountries: "países",
      guaranteeBadge: "Garantía respaldada por la clínica",
      guaranteeBadgeSub: "Firmada con tu clínica en persona",
      certsTitle: "Formación y certificaciones de nuestros expertos",
      certsFootnote: "Acreditaciones de EE.UU. e internacionales · implantes y materiales de laboratorio de marca premium (<b>Straumann</b>, <b>Nobel Biocare</b>, <b>Zirkonzahn</b> y más).",
      clinicsEyebrow: "Socios, no intermediarios",
      clinicsTitle: "Clínicas que conocemos en persona",
      clinicsSub: "No somos un sitio de reservas ni un intermediario que te pasa de mano en mano. My Global Dentist se asocia directamente con cada clínica y sus dentistas — así que en calidad, precios y garantías, hay personas reales respaldándote. Hotel, traslado y concierge incluidos.",
      browseClinics: "Buscar por ubicación y filtros →",
      transformsEyebrow: "La prueba en cada sonrisa",
      transformsTitle: "Transformaciones reales de sonrisa",
      transformsSub: "Resultados reales de pacientes en nuestra red — implantes de arcada completa, All-on-4, All-on-6 y reconstrucciones de boca completa.",
      swipeMore: "Desliza para ver más →",
      seeVideos: "Ver testimonios en video",
      seeCandidate: "Ver si soy candidato",
      candidateNote: "Revisión gratis y sin compromiso — respondemos en 2 horas.",
      testimonialsEyebrow: "Historias de pacientes",
      testimonialsTitle: "En sus propias palabras",
      saraQuote: "\"Mi único arrepentimiento es no haberlo hecho antes.\"",
      saraName: "Sara Misterek",
      saraProcedure: "Restauración de boca completa con coronas",
      saraVerified: "Paciente verificada · en sus propias palabras",
      shareBold: "¿Eres uno de nuestros pacientes?",
      shareRest: "Comparte tu historia e inspira a alguien que todavía tiene miedo de dar el paso.",
      shareStory: "Comparte tu historia",
      conciergeBadge: "Concierge de viaje completo",
      conciergeTitle1: "¿Primera vez viajando al extranjero?",
      conciergeTitle2: "Te acompañamos en todo.",
      conciergeSub: "Muchos de nuestros pacientes nunca han viajado al extranjero — y está bien. Tu coordinador dedicado se encarga de cada detalle, para que solo llegues y sonrías.",
      conciergeTalk: "Habla con un coordinador ahora",
      conciergeJourney: "Ve tu plan de viaje de 4 días paso a paso",
      shuttleBadge: "Más puntos de recogida que nadie",
      shuttleTitle: "Traslados gratis desde más lugares que cualquier otro servicio dental",
      shuttleSub: "Te recogemos donde aterrizas o cruzas y te llevamos directo a tu clínica y hotel.",
      flyDomesticBold: "¿Vas a una clínica de ciudad fronteriza?",
      flyDomesticRest: "No necesitas volar internacional — vuela nacional a una ciudad de EE.UU. cercana y te recogemos para cruzarte. Para Cancún, Costa Rica, Colombia y Turquía hay vuelos directos internacionales muy fáciles.",
      arrangeShuttle: "Coordina mi traslado",
      allPickups: "Todos los puntos de recogida",
      noCity: "¿No ves tu ciudad? Habla con un coordinador",
      vettedEyebrow: "La prueba, no solo una promesa",
      vettedTitle: "Hemos estado dentro de cada clínica de este sitio",
      vettedSub: "Estas son nuestras propias visitas — inspeccionando cada instalación, conociendo a los doctores y otorgando nuestro Reconocimiento Internacional de Calidad antes de que una clínica entre a la red. Si no hemos estado ahí en persona, no las encontrarás aquí.",
      vettedFootnote: "Cada clínica socia es inspeccionada en persona y certificada en calidad por nuestro fundador.",
      vettedVisiting: "El fundador visitando {name}",
      howEyebrow: "Simple y transparente",
      howTitle: "Cómo funciona",
      howSub: "Desde la primera cotización hasta la sonrisa final, nos encargamos de los detalles para que viajes con confianza.",
      founderEyebrow: "Un mensaje de nuestro fundador",
      founderTitle: "Tu sonrisa merece un cuidado en el que puedas confiar",
      founderP1: "\"Fundé My Global Dentist después de ver a demasiadas familias trabajadoras posponer el cuidado dental que necesitaban simplemente porque costaba demasiado en casa. Eso nunca me pareció justo.",
      founderP2: "Así que empecé a viajar — recorriendo clínicas por México, Costa Rica, Colombia y Turquía, conociendo a los dentistas, revisando las salas de esterilización y haciendo las preguntas que <i>tú</i> harías. Solo las mejores ganan un lugar en nuestra red.",
      founderP3: "Casi 16,000 pacientes después, esto sigue siendo personal para mí. Cuando nos contactas, no eres un número — eres alguien a quien guiaremos, protegeremos y celebraremos cuando por fin veas tu nueva sonrisa en el espejo.\"",
      founderRole: "Fundador, My Global Dentist",
      founderReach: "¿Quieres contactarme personalmente?",
      founderReadMsg: "Yo leo cada mensaje personalmente.",
      founderTalk: "Habla con nuestro equipo",
      founderReadFull: "Lee mi bienvenida completa",
      destEyebrow: "Dónde trabajamos",
      destTitle: "Explora nuestros destinos",
      destAll: "Todos los destinos →",
      mathEyebrow: "La cuenta es simple",
      mathTitle: "Ahorra 50–70% — los mismos materiales premium",
      mathSub: "Los mismos materiales premium, los mismos especialistas formados en EE.UU. — a una fracción del precio. Esto es lo que nuestros pacientes suelen pagar frente a Estados Unidos.",
      inUsa: "En EE.UU.",
      withUsFrom: "Con nosotros desde",
      saveUpTo: "Ahorra hasta {save}",
      mathFootnote: "Rangos típicos todo incluido. Tu precio exacto se confirma en tu cotización gratis por escrito.",
      getWrittenQuote: "Obtén mi cotización por escrito",
      faqEyebrow: "Tus preguntas, respondidas",
      faqTitle: "Preguntas frecuentes",
      humanBadge: "Personas reales · Sin bots",
      humanTitle: "Habla con una persona real, no con un bot.",
      humanSub: "Habla con un coordinador con experiencia que ya ayudó a miles de pacientes. Te explica tus opciones, costos y tiempos — sin presión y sin guiones.",
      humanQuoteBtn: "Cotización gratis",
      humanCallBtn: "Llama a un coordinador",
      finalTitle: "¿No sabes por dónde empezar?",
      finalSub: "Nuestro equipo de atención al paciente está aquí para guiarte en cada paso. Recibe una cotización gratis y sin compromiso — respondemos en 2 horas.",
      compareRows: [
        { t: "All-on-4 (por arcada)", us: "$26,000", ours: "$8,500", save: "67%" },
        { t: "Implante individual", us: "$4,000", ours: "$800", save: "80%" },
        { t: "Carilla de porcelana (c/u)", us: "$1,800", ours: "$400", save: "78%" },
      ],
      guarantees: [
        { t: "Garantía de tratamiento respaldada por la clínica", d: "Firmada directamente entre tú y tu clínica, en persona." },
        { t: "Dentistas certificados y formados en EE.UU.", d: "Solo miembros de la ADA y especialistas con acreditación internacional." },
        { t: "Sin cargos ocultos, nunca", d: "Un precio todo incluido y transparente — cirugía, materiales y seguimiento." },
      ],
      concierge: [
        { title: "Ayuda para reservar vuelos", desc: "Te ayudamos a encontrar y reservar los mejores vuelos para tus fechas de tratamiento." },
        { title: "Recogida en aeropuerto y frontera", desc: "Traslados gratis desde aeropuertos internacionales, cruces fronterizos de EE.UU. y puntos de recogida en la ciudad — directo a tu clínica y hotel." },
        { title: "Hoteles y Airbnbs privados", desc: "Hoteles con tarifa preferencial y Airbnbs privados seleccionados cerca de tu clínica, según tu presupuesto." },
        { title: "Apoyo bilingüe", desc: "Personal y coordinadores que hablan español contigo en cada cita." },
      ],
      steps: [
        { title: "Recibe una cotización gratis", desc: "Cuéntanos tu tratamiento. Recibe un plan personalizado y precio en 2 horas." },
        { title: "Te emparejamos con una clínica", desc: "Te conectamos con una clínica seleccionada, formada en EE.UU. y con personal bilingüe." },
        { title: "Viaja y trátate", desc: "Coordinamos vuelos, hoteles y citas de principio a fin." },
        { title: "Sonríe y ahorra", desc: "Regresa a casa con una nueva sonrisa — y hasta 70% de ahorro." },
      ],
      faqs: [
        { q: "¿El turismo dental es realmente seguro?", a: "Sí — cuando eliges la clínica correcta. Cada clínica de nuestra red es seleccionada a mano y verificada por su acreditación (ADA, ISO, JCI), esterilización moderna, dentistas formados en EE.UU./Europa y reseñas verificadas de pacientes. Hemos recorrido sus instalaciones en persona." },
        { q: "¿Cómo pueden ser los precios 70% más bajos — es peor la calidad?", a: "No. Los costos más bajos vienen de menores gastos operativos, de mano de obra y de seguros en el extranjero, no de menor calidad. Nuestras clínicas socias usan las mismas marcas y materiales premium de implantes (Straumann, Nobel, Zirconio) que tendrías en casa." },
        { q: "¿Realmente ahorraré dinero después de vuelos y hotel?", a: "Para la mayoría de los tratamientos grandes, sin duda. En un implante individual ahorras ~$2,600; en All-on-4 o carillas completas ahorras $10,000–$40,000 — mucho más que cualquier costo de viaje. Muchos pacientes lo toman como unas vacaciones pagadas." },
        { q: "¿Cuánto tiempo necesito quedarme?", a: "Depende del tratamiento. Coronas y carillas suelen tomar de 3 a 5 días; los implantes pueden necesitar un viaje corto para la colocación y un seguimiento para la corona. Tu coordinador planea todo según tu agenda." },
        { q: "¿Qué pasa si algo sale mal cuando llego a casa?", a: "Tu clínica ofrece una garantía de tratamiento por escrito que revisan y firman juntos en persona, y nuestro equipo de atención te acompaña antes, durante y después de tu viaje para coordinar cualquier seguimiento necesario." },
        { q: "¿Cómo empiezo?", a: "Pide una cotización gratis (toma menos de un minuto) o escríbenos por WhatsApp. Te enviaremos un plan de tratamiento personalizado y precio en 24 horas — sin compromiso." },
      ],
      locations: {
        tijuana: { title: "Tijuana, México", sub: "Vuela desde cualquier parte de EE.UU. · traslados desde San Diego y Palm Springs" },
        mexicali: { title: "Mexicali, México", sub: "Vuela desde cualquier parte de EE.UU. · traslado desde Calexico, CA" },
        algodones: { title: "Los Algodones, México", sub: "\u201CMolar City\u201D · Vuela desde cualquier parte de EE.UU. · traslados desde San Diego, Yuma y Phoenix" },
        cancun: { title: "Cancún, México", sub: "Vuelos directos desde EE.UU. y Canadá" },
        costarica: { title: "San José, Costa Rica", sub: "Vuelos directos desde EE.UU. y Canadá" },
        colombia: { title: "Bogotá, Colombia", sub: "Vuelos directos desde EE.UU. y Canadá" },
        turkey: { title: "Estambul, Turquía", sub: "La capital mundial de los diseños de sonrisa" },
        progreso: { title: "Nuevo Progreso, México", sub: "Vuela desde cualquier parte de EE.UU. · traslado desde McAllen, TX" },
      },
    },
    ad: {
      differentiators: [
        { t: "Socios, no intermediarios", d: "Cada clínica verificada en persona" },
        { t: "Dentistas formados en EE.UU.", d: "Especialistas acreditados ADA / AACD" },
        { t: "Garantía respaldada por la clínica", d: "Firmada con tu clínica, en persona" },
        { t: "Viaje todo incluido", d: "Hotel, traslado gratis y concierge bilingüe" },
      ],
      times: ["Mañana (8am–12pm)", "Tarde (12–5pm)", "Noche (5–8pm)", "Cualquier hora"],
      variants: {
        implants: { eyebrow: "Implantes dentales en el extranjero", h1a: "Implantes dentales por", h1b: "hasta 77% menos", sub: "Especialistas formados en EE.UU. e implantes genuinos Straumann y Nobel — desde $800 vs. ~$4,000 en EE.UU. La misma calidad premium, a una fracción del precio.", unit: "por implante" },
        "all-on-4": { eyebrow: "All-on-4 arcada completa", h1a: "Una sonrisa nueva con", h1b: "All-on-4 — ahorra hasta 67%", sub: "Dientes fijos de arcada completa sobre 4 implantes — desde $8,500 por arcada vs. ~$26,000 en EE.UU. Cirujanos formados en EE.UU., materiales premium y un viaje todo incluido.", unit: "por arcada" },
        "veneers-crowns": { eyebrow: "Carillas y coronas", h1a: "Una sonrisa impecable con", h1b: "carillas y coronas — ahorra hasta 78%", sub: "Carillas y coronas de porcelana hechas a mano — desde $400 c/u vs. ~$1,800 en EE.UU. Los mismos materiales premium, dentistas cosméticos formados en EE.UU.", unit: "por diente" },
      },
      avg: "promedio",
      patientsGuided: "pacientes acompañados",
      thankYou: "¡Gracias! 🎉",
      thankYouSub: "Nuestro equipo te enviará tu cotización personalizada en 2 horas. ¿Prefieres chatear ahora?",
      freeReply2h: "Gratis · respuesta en 2h",
      formTitle: "Obtén tu cotización gratis por escrito",
      formSub: "Sin compromiso. 100% confidencial.",
      fullName: "Nombre completo",
      email: "Correo electrónico",
      phoneWa: "Teléfono / WhatsApp",
      bestTime: "Mejor hora para llamar",
      chooseTime: "Elige una hora",
      error: "Algo salió mal. Inténtalo de nuevo o escríbenos por WhatsApp.",
      mathEyebrow: "La cuenta es simple",
      inUsa: "En EE.UU.",
      withUsFrom: "Con nosotros desde",
      saveUpTo: "Ahorra hasta {save}",
      mathFootnote: "Rango típico todo incluido. Tu precio exacto se confirma en tu cotización gratis por escrito.",
      proofEyebrow: "La prueba en cada sonrisa",
      proofTitle: "Pacientes reales, resultados reales",
      watchVideos: "Ver testimonios en video",
      finalTitle: "¿Listo para ver tus ahorros?",
      finalSub: "Recibe una cotización gratis y sin compromiso — nuestro equipo responde en 2 horas.",
      exploreFull: "Explora el sitio completo de My Global Dentist →",
    },
    compare: {
      eyebrow: "Encuentra tu clínica ideal",
      title: "Compara clínicas dentales",
      sub: "Explora clínicas acreditadas por ubicación, o filtra por procedimiento, precio y certificaciones.",
      filters: "Filtros",
      reset: "Restablecer",
      country: "País",
      anyCountry: "Cualquier país",
      procedure: "Procedimiento",
      anyProcedure: "Cualquier procedimiento",
      certification: "Certificación",
      anyCertification: "Cualquier certificación",
      maxPrice: "Precio inicial máximo:",
      allLocations: "Todas las ubicaciones",
      found: "{n} clínicas encontradas",
      foundOne: "1 clínica encontrada",
      noMatch: "Ninguna clínica coincide con tus filtros.",
      clearFilters: "Limpiar filtros",
      cityGuide: "Guía de {city} →",
    },
    video: {
      back: "Volver al inicio",
      badge: "Pacientes reales · resultados reales",
      title: "Testimonios en video",
      subN: "{n} historias reales de pacientes de nuestras clínicas socias en México, Costa Rica, Colombia y Turquía — en sus propias palabras.",
      sub: "Historias reales de pacientes de nuestras clínicas socias en México, Costa Rica, Colombia y Turquía — en sus propias palabras.",
      loading: "Cargando historias en video…",
      ctaTitle: "¿Listo para escribir tu propia historia?",
      ctaSub: "Recibe un plan de tratamiento y precio gratis y sin compromiso — respondemos en 2 horas.",
    },
    transforms: {
      back: "Inicio",
      eyebrow: "La prueba en cada sonrisa",
      title: "Transformaciones reales de sonrisa",
      sub: "Resultados reales de pacientes reales en nuestra red — implantes de arcada completa, All-on-4, All-on-6 y reconstrucciones de boca completa. Mira el antes y después lado a lado.",
      ctaTitle: "Tu transformación podría ser la siguiente",
      ctaSub: "Recibe un plan de tratamiento personalizado y precio gratis en 2 horas — sin compromiso.",
    },
    stories: {
      eyebrow: "Personas reales, sonrisas reales",
      title: "Historias de pacientes",
      sub: "Experiencias auténticas de pacientes en nuestras clínicas de México, Costa Rica, Colombia y Turquía.",
      emptyTitle: "Nuestras primeras historias están en camino",
      emptySub: "Somos una red en crecimiento y solo publicamos experiencias de pacientes <b>reales y verificadas</b> — nunca reseñas falsas. Si viajaste con nosotros, nos encantaría mostrar tu sonrisa.",
      share: "Comparte tu historia",
      ctaTitle: "¿Viajaste con nosotros? Comparte tu sonrisa.",
      ctaSub: "Ayuda a futuros pacientes a sentirse seguros — agrega tu historia, foto o video.",
      watchVideo: "Ver historia en video",
    },
    share: {
      procedures: ["Carillas completas", "Coronas", "Implante dental", "All on 4", "All on 6", "Endodoncia", "Blanqueamiento", "Diseño de sonrisa", "Otro"],
      errValidate: "Por favor agrega tu nombre y una historia de al menos 10 caracteres.",
      errSubmit: "No se pudo enviar",
      thankYou: "¡Gracias, {name}!",
      thankYouSub: "Hemos recibido tu historia. Nuestro equipo revisa cada envío para mantener nuestra galería <b>100% real</b> — una vez aprobada, tu sonrisa ayudará a futuros pacientes a sentirse seguros.",
      viewStories: "Ver historias de pacientes",
      title: "Comparte la historia de tu sonrisa",
      sub: "¿Viajaste con nosotros? Inspira al siguiente paciente. Solo publicamos experiencias <b>reales y verificadas</b> — nunca reseñas falsas.",
      name: "Tu nombre *",
      from: "De dónde eres",
      procedure: "Procedimiento",
      select: "Selecciona",
      clinic: "Clínica que visitaste",
      emailLabel: "Tu correo electrónico",
      emailPrivate: "(privado, para poder verificar)",
      rating: "Tu calificación",
      story: "Tu historia *",
      storyPlaceholder: "Cuéntanos tu experiencia — los resultados, la atención, el viaje…",
      addPhoto: "Agregar una foto (opcional)",
      addVideo: "Agregar un video (opcional)",
      submit: "Enviar mi historia",
      reviewed: "Revisado por nuestro equipo antes de publicar",
    },
    locations: {
      eyebrow: "Dónde trabajamos",
      title: "Nuestros destinos",
      sub: "Ciudades dentales seleccionadas a mano en México, Costa Rica, Colombia y Turquía. Explora cada destino — qué hacer, cómo llegar y las clínicas que te esperan.",
      explore: "Explora {city}",
      notFound: "Destino no encontrado.",
      allDestinations: "Todos los destinos",
      about: "Sobre {city}",
      whatToDo: "Qué hacer en {city}",
      howToGet: "Cómo llegar a {city}",
      coordinatorPickup: "Tu coordinador organiza la recogida y te guía en todo el camino.",
      clinicsIn: "Clínicas en {city}",
      clinicsNear: "Clínicas cerca de {city}",
      addingSoon: "Pronto agregaremos clínicas en {city} —",
      requestQuote: "pide una cotización",
      addingSoon2: "y te conectaremos con la mejor opción.",
      quickFacts: "Datos rápidos",
      factGetting: "Cómo llegar",
      factEntry: "Punto de entrada",
      factCurrency: "Moneda",
      factLanguage: "Idioma",
      factWeather: "Clima",
      factBestFor: "Ideal para",
      planTrip: "Planea tu viaje a {city}",
      planSub: "Cotización gratis y coordinación completa del viaje — respondemos en 2 horas.",
    },
    trip: {
      badge: "Concierge de viaje completo",
      title: "Qué esperar en tu viaje",
      sub: "Un viaje dental típico toma unos <b>4 días</b>. Así funciona exactamente — planeado de principio a fin por tu coordinador de pacientes dedicado, para que quienes viajan por primera vez se sientan totalmente tranquilos.",
      goodToKnow: "Bueno saber:",
      goodToKnowRest: "los tiempos varían según el tratamiento. Coronas y carillas simples pueden hacerse en 3–4 días, mientras que los implantes a veces necesitan una segunda visita corta para la corona final una vez completada la cicatrización. Tu coordinador adapta el plan a tu caso y fechas de viaje.",
      ctaTitle: "¿Listo para planear tu viaje?",
      ctaSub: "Cuéntanos tu tratamiento y fechas de viaje — armaremos tu plan día a día y una cotización gratis en 2 horas.",
      days: [
        { day: "Día 1", title: "Llegada y bienvenida", points: ["Aterrizas — tu coordinador organiza la recogida en el aeropuerto o la frontera.", "Te registras en un hotel socio cerca de tu clínica con tarifas preferenciales.", "Relájate y acomódate; hoy no hay tratamiento."] },
        { day: "Día 2", title: "Consulta y plan de tratamiento", points: ["Visitas la clínica para un examen completo, radiografías digitales y escaneo 3D.", "Tu dentista confirma un plan de tratamiento personalizado y el precio final.", "Comienza la primera etapa (limpieza, preparación o provisionales)."] },
        { day: "Día 3", title: "Día de tratamiento", points: ["Tu procedimiento principal — colocación de implantes, carillas o coronas.", "Atención cómoda y con manejo del dolor, con tu coordinador bilingüe cerca.", "Tiempo para descansar y disfrutar la ciudad entre citas."] },
        { day: "Día 4", title: "Ajuste final y vuelo a casa", points: ["Ajustes finales, colocación y control de calidad de tu nueva sonrisa.", "Instrucciones claras de cuidado y el contacto directo de tu coordinador.", "Transporte organizado de regreso al aeropuerto o la frontera — vuela a casa sonriendo."] },
      ],
    },
    blog: {
      eyebrow: "Recursos",
      title: "Guías de turismo dental",
      sub: "Todo lo que necesitas para planear un viaje seguro y accesible para tu sonrisa.",
      readGuide: "Leer guía →",
      notFound: "Publicación no encontrada.",
      backToGuides: "Volver a las guías",
      allGuides: "Todas las guías",
      by: "Por {author}",
      ctaTitle: "¿Listo para ahorrar en tu tratamiento?",
      ctaSub: "Recibe una cotización personalizada gratis de una clínica verificada.",
    },
    clinic: {
      notFound: "Clínica no encontrada.",
      backToClinics: "Todas las clínicas",
      featured: "Destacada",
      reviews: "{n} reseñas",
      yrsExp: "{n} años de experiencia",
      certifications: "Certificaciones",
      languagesSpoken: "Idiomas que hablan",
      inHouseLab: "Laboratorio propio",
      whatsIncluded: "Qué incluye",
      allInclusive: "Paquetes todo incluido",
      allInclusiveSub: "Atención todo incluido, transparente y coordinada para ti — tratamiento, hotel y traslados al aeropuerto incluidos. Cada caso es único, así que habla con un coordinador para tu paquete personalizado.",
      allInclusiveBadge: "Paquete todo incluido",
      pricingFor: "Precio de este paquete:",
      talkToCoordinator: "Habla con un coordinador",
      pkgo: {
        "All-on 4/6 Full Arch": "All-on 4/6 arcada completa",
        "As many implants as necessary": "Los implantes que sean necesarios",
        "Three nights of hotel per trip": "Tres noches de hotel por viaje",
        "Four nights of hotel per trip": "Cuatro noches de hotel por viaje",
        "Five nights of hotel per trip": "Cinco noches de hotel por viaje",
        "Five nights of hotel · Renaissance Hotel": "Cinco noches de hotel · Hotel Renaissance",
      },
      smileTransforms: "Transformaciones de sonrisa",
      dragSlider: "Arrastra el control para revelar resultados reales de antes y después.",
      featuredCase: "Caso destacado de arcada completa",
      patientStories: "Historias de pacientes",
      patientStoriesSub: "Experiencias reales y verificadas de pacientes atendidos aquí.",
      patientVideos: "Videos de pacientes",
      location: "Ubicación",
      mapNote: "Tu coordinador te envía las indicaciones exactas y organiza tu traslado gratis desde la frontera o el aeropuerto — no tienes que encontrarnos por tu cuenta.",
      stickyEyebrow: "Paquetes todo incluido",
      stickySave: "Ahorra hasta 70% vs. EE.UU.",
      stickySub: "Tratamiento, hotel y recogida en aeropuerto — coordinados para ti. Respondemos en 2 horas.",
      respond2h: "Respondemos en 2 horas",
      waMessage: "¡Hola! Me interesa un tratamiento en {name}.",
      highlights: { "First clinic after the bridge": "Primera clínica después del puente", "Open Sundays": "Abierto los domingos" },
      proximity: {
        "Mexicali": "A unos 5 minutos de la frontera de Calexico (California), EE.UU.",
        "Tijuana": "A unos 15–20 minutos de la frontera de San Diego (San Ysidro), EE.UU.",
        "Los Algodones": "A distancia caminando de la frontera de Andrade / Yuma (Arizona), EE.UU.",
        "Nuevo Progreso": "A pasos de la frontera de Progreso (Weslaco, Texas), EE.UU.",
        "Cancún": "A unos 20 minutos del Aeropuerto Internacional de Cancún (CUN)",
        "Bogotá": "A unos 25 minutos del Aeropuerto Internacional El Dorado (BOG)",
        "San José": "A unos 20 minutos del Aeropuerto Internacional Juan Santamaría (SJO)",
        "Istanbul": "A unos 40 minutos del Aeropuerto de Estambul (IST)",
      },
      packages: {
        allOnDefault: "All-on-4 arcada completa",
        allOnTagline: "Dientes fijos y permanentes — arcada completa",
        allOnItems: ["Tomografías y evaluaciones", "Consultas con especialistas", "Sedación IV", "Extracciones", "Injerto óseo", "Cuatro implantes por maxilar", "Dientes fijos provisionales", "Dientes permanentes finales", "3 noches de hotel por viaje", "Traslados al aeropuerto (ida y vuelta)"],
        smileName: "Diseño de sonrisa · Boca completa",
        smileTagline: "Restauración de boca completa con coronas",
        smileItems: ["Tomografía y evaluaciones", "Consultas con especialistas", "Hasta 24 coronas de zirconio / E.max", "Diseño Digital de Sonrisa", "Todo el trabajo de laboratorio", "Hotel y traslados incluidos"],
      },
    },
    card: {
      hotel: "Hotel", shuttle: "Traslado", concierge: "Concierge", featured: "Destacada",
      highlights: { "First after the bridge": "Primera tras el puente", "Open Sundays": "Abierto domingos" },
      proximity: {
        "Mexicali": "5 min de la frontera de EE.UU.",
        "Tijuana": "15 min de la frontera de EE.UU.",
        "Los Algodones": "Cruza caminando la frontera de EE.UU.",
        "Nuevo Progreso": "A pasos de la frontera de EE.UU.",
        "Cancún": "20 min del aeropuerto CUN",
        "Bogotá": "30 min del aeropuerto BOG",
        "San José": "20 min del aeropuerto SJO",
        "Istanbul": "40 min del aeropuerto IST",
      },
    },
    tcard: { before: "Antes", after: "Después", realPatient: "Paciente real" },
  },
};
